module.exports = __webpack_public_path__ + "img/ball_0.6de6f405.png";